import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Label,
  AmountContainer,
  Amount,
  InfoIconContainer,
  Total,
  PriceWrapper,
} from './PriceBreakdown.styles';
import InfoIcon from '../../../assets/icons/Info';
import { COLORS } from '../../../styles/variables';

interface PriceItemProps {
  priceKey: string;
  label: string;
  priceValue: string;
  shortDisclaimer: string;
  longDisclaimer: string;
  handleOpenModal: (e: any, legalText: string) => void;
  isBold?: boolean;
}

const PriceItem: React.FC<PriceItemProps> = ({
  label,
  priceValue,
  longDisclaimer,
  shortDisclaimer,
  handleOpenModal,
  isBold,
}) => {
  const { t } = useTranslation();
  const hasLongDisclaimer = useMemo(() => {
    return !!longDisclaimer?.length;
  }, [longDisclaimer?.length]);
  // use this for author entered price break down settings

  return (
    <>
      <PriceWrapper>
        <Label>{label}</Label>
        <AmountContainer
          aria-label={`${label} legal Disclaimer`}
          onClick={(e) => handleOpenModal(e, longDisclaimer || '')}
          alignCenter
          isSelectable={hasLongDisclaimer}
        >
          {isBold ? <Total>{priceValue}</Total> : <Amount largeFont>{priceValue}</Amount>}
          <InfoIconContainer>
            {hasLongDisclaimer && <InfoIcon color={COLORS.grey60} size={16} />}
          </InfoIconContainer>
        </AmountContainer>
      </PriceWrapper>
      {!!shortDisclaimer?.length && <Label color={COLORS.grey60}>{shortDisclaimer}</Label>}
    </>
  );
};

export default PriceItem;
